import { RouteLocationNormalized } from "vue-router";
import useBreadcrumbStore from "../stores/breadcrumb.store";

export default function(to: RouteLocationNormalized) {
  const breadcrumbStore = useBreadcrumbStore();
  breadcrumbStore.updateBreadcrumb(to);
}